export * from './emoji-selector.component'



// WEBPACK FOOTER //
// ./src/app/shared/components/emoji-selector/index.ts